import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Shown by VersionCheckService when a newer frontend build has been deployed
 * while this tab was open.
 */
@Component({
  selector: 'app-new-version-modal',
  standalone: true,
  templateUrl: './new-version-modal.component.html',
  styleUrl: './new-version-modal.component.scss'
})
export class NewVersionModalComponent {

  constructor(public bsModalRef: BsModalRef) { }

  reload() {
    window.location.reload();
  }

  later() {
    this.bsModalRef.hide();
  }
}
